import { IconProps } from "./types";

export const ArrowRightIcon = ({
  size = 18,
  color = "currentColor",
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.878 10a.95.95 0 0 0-.28-.672l-4.76-4.764A.953.953 0 1 0 6.49 5.911l4.088 4.09-4.088 4.09a.953.953 0 0 0 1.347 1.346l4.761-4.763a.95.95 0 0 0 .28-.673"
      fill={color}
    />
  </svg>
);